import { render, staticRenderFns } from "./DettaglioBolla.vue?vue&type=template&id=d24e0f86&scoped=true&"
import script from "./DettaglioBolla.vue?vue&type=script&lang=js&"
export * from "./DettaglioBolla.vue?vue&type=script&lang=js&"
import style0 from "./DettaglioBolla.vue?vue&type=style&index=0&id=d24e0f86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24e0f86",
  null
  
)

export default component.exports